// English [en-us]

const numbers = {
  decimal: '.',
  thousands: ',',
  grouping: [3],
};

export default numbers;
